module.exports = {
      id: "personas:four-usage",
      viewBox: "0 0 40 42",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#personas:four-usage",
      toString: function () {
        return this.url;
      }
    }